import { z } from 'zod';
import { ZERO } from '@/constants/common';

export const mapOverlaySchema = z.object({
  id: z.number().int().positive(),
  group: z.number().int().positive().nullable(),
  name: z.string(),
  order: z.number().int().gte(ZERO),
  creator: z.number(),
  description: z.string(),
  genomeType: z.string().nullable(),
  genomeVersion: z.string().nullable(),
  publicOverlay: z.boolean(),
  type: z.string(),
  notMatchingAlpha: z.number().nullable(),
});
